// TODO: need to persist this in Firebase (from dev tooling),
// currently putting here so we can get it in prod as soon as possible.

// FORMAT: Key Line Item ID is EXCLUDED BY Value Line Item IDs
export const MutuallyExcludedLineItems: { [key: string]: string[] } = {
	"817eb841-7c68-4f9a-9b67-403e90948569": [
		"fe0cc083-e0bc-458b-a29e-8201181e84e3",
		"f73648cd-bd91-4d8a-b495-7610deeb021a",
		"61ddf203-fe69-4964-a849-6ab5380cfa9b",
		"bc8111a8-8459-416a-8e5e-0216dff2108e",
	],
	"efc701c2-09cc-4ac5-a23c-57ea4e12fa34": ["b771a2db-4f62-4126-8566-f7fa3eddcad0"],
	"94770d8d-4f2e-4648-ab42-5ccbe380cc18": ["5e3ecbb4-c9c8-48e2-a64c-d303c6267839"],
	"694f5b2f-accb-4d2c-b9b6-bf7d4e032652": ["0b925fdd-e036-4066-9463-dfcc3f1b8513"],
	"4e4a7bc6-f617-4db0-bf1b-1ece33fd867a": ["23177a91-d176-4d02-a819-f36cffdc7d20"],
};
